<template>
  <div>
    <form-group :validations="validation">
      <div slot-scope="{ errors, invalid }">
        <input type="file" id="select_single_image" name="select_single_image" accept="image/*" class="d-none"
               @input="onSingleFileChange">
        <label for="select_single_image">
          <img v-bind="mainPicProps" :src="previewController()" class="card rounded" :class="{ invalid }" alt="">
        </label>

        <form-errors-manager :errors="errors"/>
      </div>
    </form-group>
  </div>
</template>
<script>
import FormGroup from "../../../validator/FormGroup.vue";
import FormErrorsManager from "../../../validator/FormErrorsManager.vue";

export default {
  name: "SingleImage",
  props: ["mainImage", "mainPreview", "validation"],
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      mainPicProps: {
        blank: true,
        blankColor: "#fff",
        width: 150,
        height: 150,
        class: "m1",
      },
      preview: '',
      status: 1, // create mode
    };
  },
  model: {
    prop: 'mainImage',
    event: 'input'
  },
  methods: {
    onSingleFileChange(e) {
      this.mainPicProps.blank = false;
      const file = e.target.files[0];
      this.status = 0
      this.preview = URL.createObjectURL(file);
      this.$emit('input', file)

    },
    previewController() {
      if (this.mainPreview !== "" && this.status === 1) {
        this.preview = this.mainPreview;
        return this.preview
      }
      return this.preview
    }
  }
};
</script>